import { AdminDashboard } from "./adminDashboard";
import { Notifications } from "../../../../ui/blocks/notifications/notifications";

export function AdminNotifications() {

  return (
    <AdminDashboard>
      <Notifications/>
    </AdminDashboard>
  );
}
